exports.ALL = [
  {
    "Name": "Accountant",
    "Daily Wage": "",
    "Monthly Wage": "",
    "Monthly Live-In Wage": "",
    "Space": "10'+20'",
    "Share": "",
    "Special": "5% commission on money handled",
    "Wealth": "2",
    "Gear": "scholar|misc",
  },
  {
    "Name": "Animal Handler",
    "Daily Wage": "$14.00",
    "Monthly Wage": "$140.00",
    "Monthly Live-In Wage": "$105.00",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "2",
    "Gear": "adventure|misc,strange",
  },
  {
    "Name": "Armorer",
    "Daily Wage": "",
    "Monthly Wage": "$50.00",
    "Monthly Live-In Wage": "$37.00",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "2",
    "Gear": "craft|military",
  },
  {
    "Name": "Butler",
    "Daily Wage": "",
    "Monthly Wage": "$150.00",
    "Monthly Live-In Wage": "$112.50",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "2",
    "Gear": "misc",
  },
  {
    "Name": "Coachman",
    "Daily Wage": "$6.00",
    "Monthly Wage": "$60.00",
    "Monthly Live-In Wage": "$45.00",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "2",
    "Gear": "misc",
  },
  {
    "Name": "Craftsman",
    "Daily Wage": "",
    "Monthly Wage": "$100.00",
    "Monthly Live-In Wage": "$75.00",
    "Space": "10'+20'",
    "Share": "",
    "Special": "craft",
    "Wealth": "2",
  },
  {
    "Name": "Guide",
    "Daily Wage": "$14.00",
    "Monthly Wage": "",
    "Monthly Live-In Wage": "",
    "Space": "",
    "Share": "10%",
    "Special": "",
    "Wealth": "2",
    "Gear": "adventure|wilderness",
  },
  {
    "Name": "Mercenary",
    "Special": "merc"
  },
  {
    "Name": "Mercenary",
    "Special": "merc"
  },
  {
    "Name": "Mercenary",
    "Special": "merc"
  },
  {
    "Name": "Mercenary",
    "Special": "merc"
  },
  {
    "Name": "Sailor",
    "Daily Wage": "",
    "Monthly Wage": "",
    "Monthly Live-In Wage": "$63.00",
    "Space": "",
    "Share": "20%",
    "Special": "",
    "Wealth": "2",
    "Gear": "sea|misc,strange",
  },
  {
    "Name": "Sea Captain",
    "Daily Wage": "",
    "Monthly Wage": "",
    "Monthly Live-In Wage": "$250.00",
    "Space": "",
    "Share": "100%",
    "Special": "",
    "Wealth": "2",
    "Gear": "sea|misc",
  },
  {
    "Name": "Ship Navigator",
    "Daily Wage": "",
    "Monthly Wage": "",
    "Monthly Live-In Wage": "$100.00",
    "Space": "",
    "Share": "50%",
    "Special": "",
    "Wealth": "2",
    "Gear": "sea|misc",
  },
  {
    "Name": "Slave Master",
    "Daily Wage": "",
    "Monthly Wage": "$70.00",
    "Monthly Live-In Wage": "$52.50",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "2",
    "Gear": "misc",
  },
  {
    "Name": "Teamster",
    "Daily Wage": "$10.00",
    "Monthly Wage": "$100.00",
    "Monthly Live-In Wage": "$75.00",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "2",
    "Gear": "wilderness|misc",
  }
];


// WEBPACK FOOTER //
// ./src/data/skilled-occupations.js